import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=21ec10d8&scoped=true&"
import script from "./ClientsList.vue?vue&type=script&lang=ts&"
export * from "./ClientsList.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=21ec10d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec10d8",
  null
  
)

export default component.exports